export const messages = {
  header: {
    id: "bible-note.header",
    defaultMessage: "You added a note to",
  },
};
